import React from "react";
import { Row, Col } from "react-bootstrap";
import AddAddressHook from "../../hook/user/add-address-hook";
import { ToastContainer } from "react-toastify";
import DisableButton from "../Uitily/DisableButton";
const UserAddAddress = () => {
  const [
    alias,
    detalis,
    phone,
    onChangeAlias,
    onChangeDetalis,
    onChangePhone,
    onSubmit,
    checkISCompleate,
  ] = AddAddressHook();
  return (
    <div>
      <Row className="justify-content-start ">
        <div className="admin-content-text pb-2">اضافة عنوان جديد</div>
        <Col sm="8">
          <input
            value={alias}
            onChange={onChangeAlias}
            type="text"
            className="input-form d-block mt-3 px-3"
            placeholder="تسمية العنوان مثلا(المنزل - العمل)"
          />
          <textarea
            value={detalis}
            onChange={onChangeDetalis}
            className="input-form-area p-2 mt-3"
            rows="4"
            cols="50"
            placeholder="العنوان بالتفصيل"
          />
          <input
            value={phone}
            onChange={onChangePhone}
            type="text"
            className="input-form d-block mt-3 px-3"
            placeholder="رقم الهاتف"
          />
        </Col>
      </Row>
      <Row>
        <Col sm="8" className="d-flex justify-content-end ">
          {checkISCompleate ? (
            <button onClick={onSubmit} className="btn-save d-inline mt-2 ">
              اضافة عنوان
            </button>
          ) : (
            <DisableButton title="اضافة عنوان" />
          )}
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default UserAddAddress;
